import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user';
import { ResponsiveService } from '../../core/responsive.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'], // Updated to .scss
  standalone : false
})
export class HeaderComponent implements OnInit {
  @Input() loginMode = false;
  userEmail: string | null = null;
  isHandset$!: Observable<boolean>;
  isAuthenticated = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private responsive: ResponsiveService
  ) {}

  ngOnInit() {
  // expose responsive stream
  this.isHandset$ = this.responsive.isHandset$;
    this.setUserEmail();
    this.isAuthenticated = this.authService.isAuthenticated();
    // Listen for navigation events to update userEmail after login/logout
    this.router.events.subscribe(() => {
      this.setUserEmail();
      this.isAuthenticated = this.authService.isAuthenticated();
    });

    // Listen for auth state changes to update UI in real-time
    this.authService.authStateChanged$.subscribe(() => {
      this.setUserEmail();
      this.isAuthenticated = this.authService.isAuthenticated();
    });
  }

  setUserEmail() {
    this.userEmail = this.authService.getUserEmail();
  }

  logout() {
    this.authService.logout();
    this.setUserEmail();
    // Full reload ensures a stale in-memory bundle in long-open tabs is replaced after new deploys
    window.location.href = '/login';
  }
}
